import { getAccessToken, getOAuthToken } from "Helpers/api";
import { authStore } from "Stores/AuthStore";

type Method = "GET" | "POST" | "PATCH" | "PUT" | "DELETE";

interface RequestConfig {
    method?: Method;
    body?: any;
    headers?: Record<string, string>;
}

const authorizedFetch = async (
    url: string,
    options: RequestInit,
    retryCount = 0
): Promise<Response> => {
    const oauthToken = await getOAuthToken();
    const response = await fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            Authorization: `Bearer ${oauthToken}`,
        },
    });
    if (response.status === 401 && retryCount < 3) {
        try {
            await authStore.fetchOAuthToken();
            return authorizedFetch(url, options, retryCount + 1);
        } catch (err) {
            console.error("Token refresh failed:", err);
            throw err;
        }
    }
    return response;
};

export const apiRequest = async (
    url: string,
    { method = "GET", body, headers = {} }: RequestConfig = {}
) => {
    const response = await authorizedFetch(url, {
        method,
        headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            ...(body && { "Content-Type": "application/json" }),
            ...headers
        },
        ...(body && { body: JSON.stringify(body) }),
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
        const errorObj = data || { message: "Something went wrong" };
        throw { ...errorObj, statusCode: response.status }
    }

    return data;
};